<template>
	<DialogFormDialog ref="dialog" :strings="strings" @reset="reset">
		<Wizard :is="wizardType" ref="wizard" :form.sync="values" />
	</DialogFormDialog>
</template>

<script>
import strings from "@/utils/strings";

export default {
	components: {
		temperature: () => import("./Temperature.vue"),
		trigger: () => import("./Trigger.vue"),
	},

	data() {
		return {
			wizardType: "",
			values: {},
		};
	},

	computed: {
		strings() {
			return strings.live.scenes[`${this.wizardType}WizardDialog`] || {};
		},
	},

	watch: {
		values: {
			deep: true,
			handler(newVal) {
				this.$refs.dialog.updateFormData(newVal);
			},
		},
	},

	mounted() {
		// Wrap parent pop method to capture *current* value as a placeholder.
		this.pop = (type, ...args) => {
			this.wizardType = type;
			return this.$refs.dialog.pop(...args);
		};
	},

	methods: {
		reset() {
			this.$refs.wizard.reset();
			this.values = {};
		},
	},
};
</script>
